import { all } from "redux-saga/effects";
import authSaga from "./auth/sagas";
import claimdataSaga from "./Claimdata/sagas";
import GetbalancelistSaga from "./Getbalance/sagas";
import GetprofilelistSaga from "./Profilelogin/sagas";
import GettaloadlistSaga from "./Taloadrequest/sagas";
import transactionsaga from "./Transactionhistory/sagas";

export default function* rootSaga() {
  
    yield all([
      authSaga(),
      GetbalancelistSaga(),
      claimdataSaga(),
      GettaloadlistSaga(),
      transactionsaga(),
      GetprofilelistSaga()
      
    ]);
  }
  